import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PdfReportViewer } from "./PdfReportViewer";
import { FinancialReport } from "@/config/financialStatementsConfig";

interface YearSectionProps {
  year: number;
  reports: FinancialReport[];
}

export const YearSection = ({ year, reports }: YearSectionProps) => {
  const [activeReportId, setActiveReportId] = useState<string | null>(null);

  const handleReportClick = (reportId: string) => {
    if (activeReportId === reportId) {
      setActiveReportId(null);
    } else {
      setActiveReportId(reportId);
    }
  };

  const activeReport = reports.find((r) => r.id === activeReportId);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-foreground mb-4">{year}</h2>
        <div className="flex gap-4">
          {reports.map((report) => (
            <Button
              key={report.id}
              variant={activeReportId === report.id ? "default" : "outline"}
              onClick={() => handleReportClick(report.id)}
              size="lg"
            >
              {report.label}
            </Button>
          ))}
        </div>
      </div>

      {activeReport && (
        <PdfReportViewer
          file={activeReport.file}
          title={activeReport.label}
        />
      )}
    </div>
  );
};
